<template>
  <v-card
    v-bind:class="{ archived: section.archived, hidden: (!viewArchived && section.archived) }"
    class="section"
  >
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editsection.conditional_question_id = arguments[0].question_id; editsection.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    <Preloader v-if="loading" />
    <v-toolbar
      dense
      flat
      color="rgba(0,0,0,0.09)"
      style="position:relative;"
    >
      <div
        v-if="!editing"
        v-on:dblclick="editing = true"
      >
        <a
          roll="button"
          class="handle"
          style="float:left;"
        >
          <v-icon small left>drag_handle</v-icon>
        </a>
        <strong
          v-if="section.number"
          v-html="section.number + '.'"
        ></strong>
        &nbsp;
        <span
          class="inlineLimiter"
          v-html="section.text"
          style="margin-right: 50px;"
        ></span>
        <v-chip 
          outline
          color="grey"
          small
          v-if="conditional_part"  
        >
          Conditional
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="section.read_only"  
        >
          Read Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="section.web_only"  
        >
          Web Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="section.pdf_only"  
        >
          PDF Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="section.web_collapsible"  
        >
          Collapsible
        </v-chip>
        <ArchiveButton
          style="float:right;position:absolute;right:75px;top:12px;"
          :archived="section.archived"
          @restore="restore()"
          @archive="archive()"
        />
        <a
          roll="button"
          class="section-edit-button"
          style="float:right;position:absolute;right:45px;top:12px;"
          @click="editing=true"
        >
          <v-icon
            small
            color="blue"
          >
            edit
          </v-icon>
        </a>
        <a
          roll="button"
          class="section-edit-button"
          style="float:right;position:absolute;right:10px;top:12px;"
          @click="hidden=!hidden"
        >
          <v-icon
            color="grey"
          >
            {{ hidden ? 'arrow_drop_down' : 'arrow_drop_up'}}
          </v-icon>
        </a>
      </div>
      <div
        v-if="editing"
      >
        <v-layout
          style="height:50px;"
        >
          <v-flex
            xs12
            sm3
          >
            <v-text-field
              v-model="editsection.number"
              autofocus
              label="Number"
            />
          </v-flex>
          &nbsp;&nbsp;
          <v-flex>
            <v-text-field
              v-if="!isHtmlTitle"
              v-model="editsection.text"
              label="Title"
            />
          </v-flex>
          &nbsp;&nbsp;
          <v-btn
            v-if="section.section"
            flat
            @click="htmlSection=true"
          >
            Edit as HTML
          </v-btn>
          <v-btn
            color="info"
            @click="save()"
          >
            Save
          </v-btn>
          <v-btn
            @click="editing=false"
          >
            Cancel
          </v-btn>
        </v-layout>
        <TitleHTMLEditor
          v-if="htmlSection"
          ref="htmlEditor"
          :number.sync="editsection.number"
          :html.sync="editsection.text"
          @cancel="htmlSection = false"
          @save="saveWithHTML()"
        />
      </div>
    </v-toolbar>
    <div
      v-if="editing"
      style="position: relative;min-height: 30px;background: rgba(0,0,0,0.02);"
    >
      <div
        class="adv_settings"
      >
        <span
          @click="displayAdditional=!displayAdditional"
        >
          <v-icon
            style="line-height: inherit;vertical-align: unset;padding-right: 10px;"
            size="18"
          >
            {{ displayAdditional ? 'mdi-chevron-up-circle' : 'mdi-chevron-down-circle' }}
          </v-icon>
          Additional Settings
        </span>
        <v-expand-transition>
          <div
            v-show="displayAdditional"
            style="padding: 10px 0 15px 0;"
          >
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editsection.web_only"
                  label="Web Only"
                  persistent-hint
                  hint="Do not show section on PDF"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editsection.pdf_only"
                  label="PDF Only"
                  persistent-hint
                  hint="Do not show on Web"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editsection.web_collapsible"
                  label="Collapsible"
                  persistent-hint
                  hint="Allow users to collapse section"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editsection.read_only"
                  label="Read Only"
                  persistent-hint
                  hint="Make all questions in this section read only."
                />
              </v-flex>
            </v-layout>
            <h3>Tip Dialog Text</h3>
    				<Editor
              :enable_formatting='editsection.web_only'
    					ref="tipHtmlEditor"
    					:html="section.tip_text"
              style="background: white;"
    				/>
            <v-flex xs12 sm3>
              <v-checkbox
                v-model="conditional_part"
                label="Conditional Form Part"
                persistent-hint
                hint="Display part depending on answer to question"
              />
            </v-flex>
            <v-layout 
              row 
              wrap 
              v-if="conditional_part"
            >
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editsection.conditional_question_id"
                  label="Question ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editsection.conditional_fieldtype_id"
                  label="Fieldtype ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editsection.conditional_value"
                  label="Conditional Value"
                  style="margin-right: 10px;"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editsection.conditional_apply_pdf"
                  label="Apply to PDF"
                  persistent-hint
                  hint="Hide from PDF if part fails condition"
                />
              </v-flex>
              <v-flex sm12>
                <v-btn
                  dense
                  @click="fieldSelecting = true"
                >
                  Select a field
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-expand-transition>
      </div>
    </div>
    <v-expand-transition>
      <div
        v-if="section.id"
        v-show="!hidden"
        style="padding:15px;"
      >
        <Draggable
          v-model="section.parts"
          :draggable="'.' + draggableClassName"
          handle=".handle"
          :animation="150"
          easing="cubic-bezier(1, 0, 0, 1)"
          :move="drag"
          @end="endDrag"
        >
          <FormTemplatePart
            v-for="partId in section.parts"
            :key="partId"
            :partId="partId"
            :class="draggableClassName"
          />
          <div slot="footer">
            <div
              v-show="!adding && !section.archived"
            >
              <v-menu>
                <v-btn
                  slot="activator"
                  color="white"
                  small
                >
                  Add <v-icon small>keyboard_arrow_down</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile @click.prevent="adding='section'">
                    <v-list-tile-title>Section</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click.prevent="adding='question'">
                    <v-list-tile-title>Question</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click.prevent="adding='esignature'">
                    <v-list-tile-title>Signature</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click.prevent="adding='paragraph'">
                    <v-list-tile-title>Paragraph</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click.prevent="adding='pagebreak'">
                    <v-list-tile-title>Page Break</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
            <FormTemplatePart
              v-if="adding"
              :newPart="createNewPart()"
              @cancel="adding=null"
              @save="partAdded"
            />
          </div>
        </Draggable>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Draggable from 'vuedraggable'
import FormTemplatePart from './FormTemplatePart'
import TitleHTMLEditor from './TitleHTMLEditor'
import Preloader from '@/components/global/Preloader'
import ArchiveButton from './ArchiveButton'
import Editor from '@/components/admin/Editor'
import FormTemplateFieldSelector from '@/components/admin/FormTemplateFieldSelector'

export default {
  name: 'FormTemplateSection',
  props: [ 'partId', 'newPart' ],
  components: {
    Draggable,
    TitleHTMLEditor,
    Preloader,
    ArchiveButton,
    Editor,
    FormTemplateFieldSelector
  },
  beforeCreate () {
    this.$options.components.FormTemplatePart = FormTemplatePart
  },
  data () {
    return {
      editsection: {},
      editing: false,
      adding: null,
      htmlSection: false,
      loading: false,
      hidden: false,
      displayAdditional: false,
      draggedElement: null,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  created () {
    this.editing = !(this.section.id)
    this.conditional_part = (this.section.conditional_question_id)
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived'
    ]),
    isHtmlTitle () {
      var htmlTag = /<[a-z][\s\S]*>/i
      return htmlTag.test(this.section.text)
    },
    section: function () {
      return this.partById(this.partId) || this.newPart
    },
    draggableClassName: function () {
      return 'draggable-item-for-section-' + this.section.id
    }
  },
  watch: {
    editing (val) {
      if (val) {
        this.editsection = JSON.parse(JSON.stringify(this.section))
      } else {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveSection',
      'moveSection',
      'moveQuestion',
      'moveParagraph',
      'movePagebreak'
    ]),
    save () {
      this.loading = true
      this.editsection.tip_text = this.getTipHTML()
      if(!this.conditional_part){
        this.editsection.conditional_question_id = null
        this.editsection.conditional_fieldtype_id = null
        this.editsection.conditional_apply_pdf = false
        this.editsection.conditional_value = ""
      }
      this.saveSection(this.editsection)
      .then(section => {
        this.editing = false
        this.loading = false
        this.$emit('save', section)
      })
    },
    getTipHTML () {
      var html = this.$refs.tipHtmlEditor.getHTML()
      if (html.replace(/<\/?[^>]+(>|$)/g, "").replace(" ", "") !== "") {
        return this.$refs.tipHtmlEditor.getHTML()
      } else {
        return null
      }
    },
    archive () {
      this.loading = true
      this.section.archived = true
      this.saveSection(this.section)
      .then(section => {
        this.loading = false
        this.$emit('save', section)
      })
    },
    restore () {
      this.loading = true
      this.section.archived = false
      this.saveSection(this.section)
      .then(section => {
        this.loading = false
        this.$emit('save', section)
      })
    },
    saveWithHTML () {
      this.editsection.text = this.$refs.htmlEditor.getHTML()
      this.editsection.number = this.$refs.htmlEditor.getNumber()
      this.htmlSection = false
    },
    createNewPart () {
      let newPart = {
        template: this.section.template,
        section: this.section.id
      }
      switch (this.adding) {
        case 'section':
          newPart.part_type = 's'
          break
        case 'paragraph':
          newPart.part_type = 'p'
          break
        case 'pagebreak':
          newPart.part_type = 'b'
          break
        case 'question':
          newPart.part_type = 'q'
          newPart.is_list = false
          newPart.default_rows = 1
          newPart.fieldtype = {}
          break
        case 'esignature':
          newPart.part_type = 'e'
          break
      }
      return newPart
    },
    partAdded (part) {
      this.adding = null
      this.section.parts.push(part.id)
    },
    drag(e) {
      this.draggedElement = e.draggedContext.element
    },
    endDrag (event) {
      let movedPart = this.partById(this.draggedElement)
      this.draggedElement = null

      let insert_before = null
      if (this.section.parts && this.section.parts.length > event.newIndex + 1) {
          const nextItem = this.section.parts[event.newIndex + 1]
          insert_before = typeof nextItem === 'object' ? nextItem.id : nextItem || null
      }

      if (movedPart.part_type === 's') {
        this.moveSection({ section: movedPart, insert_before })
      } else if (movedPart.part_type === 'q') {
        this.moveQuestion({ question: movedPart, insert_before })
      } else if (movedPart.part_type === 'p') {
        this.moveParagraph({ paragraph: movedPart, insert_before })
      } else if (movedPart.part_type === 'b') {
        this.movePagebreak({ pagebreak: movedPart, insert_before })
      } else {
        throw new TypeError('Unsupported part type')
      }
    }
  }
}
</script>

<style scoped>
.section-edit-button {
  margin-left: 10px;
}

.section {
  margin-bottom: 20px;
  border:1px rgba(0,0,0,0.1) solid;
}

.inlineLimiter >>> :first-child {
  display:inline;
}

.adv_settings {
    padding:0 10px;
    padding: 0 25px 0 25px;
    border-top: 1px solid rgba(0,0,0,0.1)
}

.editor__content .ProseMirror {
  min-height: 64px;
}

.hidden {
  display: none !important;
}
</style>
